module.exports = "pegasus_template/assets/hexline-pinterest.gif";